const menu = {
    profile: 'پروفایل',
    language: 'زبان',
    appearance: {
        label: 'ظاهر',
        light: 'حالت روشن',
        dark: 'حالت تاریک',
        system: 'همگام با سیستم',
    },
    sign_out: 'خروج',
};
export default Object.freeze(menu);
